import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

interface BackButtonProps {
  href?: string;
  onClick?: () => void;
  tooltip?: string;
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
  tooltipSideOffset?: number;
  className?: string;
}

export function BackButton({ 
  href, 
  onClick, 
  tooltip,
  tooltipSide = 'bottom',
  tooltipSideOffset = 10,
  className 
}: BackButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      navigate(href);
    } else {
      navigate(-1);
    }
  };

  const button = (
    <Button
      variant="secondary"
      size="icon"
      onClick={handleClick}
      // Same footprint as the sidebar toggle (SidebarToggle in
      // DashboardLayout): size-10 button, h-4 icon. The two sit on the same
      // top row, so they read as one family of controls.
      className={`!size-10 !p-0 rounded-full ${className || ''}`}
    >
      <ChevronLeft className="h-4 w-4" />
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          {button}
        </TooltipTrigger>
        <TooltipContent side={tooltipSide} sideOffset={tooltipSideOffset}>
          {tooltip}
        </TooltipContent>
      </Tooltip>
    );
  }

  return button;
}

